'use client'
import{getCookie as o}from"@sajilni/utils/js-cookie";import{Fragment as n,jsx as t}from"react/jsx-runtime";var a=({requiredPermissions:r,children:s})=>{let e=JSON.parse(o("user")||"[]");return r.some(i=>e.includes(i))?t(n,{children:s}):null};export{a};
